import gql from 'graphql-tag';
import { useQuery, type ApolloError } from '@apollo/react-hooks';

export const GET_GS_HOME_PAGE_COUNT = gql`
  query (
    $allApplicationFilter: NominationFilter
    $decisionsFilter: GsDecisionFilter
    $emailsFilter: OfferedApplicationFilter!
    $offersFilter: OfferedApplicationFilter!
    $failedFilter: FailedApplicationListFilter!
    $panelFilter: PanelFilter
  ) {
    allApplications: nominationsPaginated(filter: $allApplicationFilter) {
      paginator {
        count
      }
    }

    decisions: gsDecisionPaginated(
      filter: $decisionsFilter
      paginator: { page: 1, limit: 10 }
    ) {
      paginator {
        count
      }
    }

    emails: offerList(filter: $emailsFilter) {
      paginator {
        count
      }
    }

    offers: offerList(filter: $offersFilter) {
      paginator {
        count
      }
    }

    panels(filter: $panelFilter) {
      _id
    }

    fails: failedApplicationPaginated(filter: $failedFilter, paginator: {}) {
      paginator {
        count
      }
    }
  }
`;

export type GetGSHomePageCount = {
  count: {
    allApplication: number;
    panels: number;
    decisions: number;
    emails: number;
    offers: number;
    fails: number;
  };
  loading: boolean;
  error: ApolloError | undefined;
};

export const useGetGSHomePageCount = (
  allApplicationFilter: any,
  panelFilter: any,
  decisionsFilter: any,
  emailsFilter: any,
  offersFilter: any,
  failedFilter: any,
): GetGSHomePageCount => {
  const { data, loading, error } = useQuery(GET_GS_HOME_PAGE_COUNT, {
    variables: {
      allApplicationFilter,
      decisionsFilter,
      emailsFilter,
      offersFilter,
      panelFilter,
      failedFilter,
    },
  });

  const count = {
    allApplication: data?.allApplications?.paginator?.count ?? 0,
    panels: data?.panels?.length ?? 0,
    decisions: data?.decisions?.paginator?.count ?? 0,
    emails: data?.emails?.paginator?.count ?? 0,
    offers: data?.offers?.paginator?.count ?? 0,
    fails: data?.fails?.paginator?.count ?? 0,
  };

  return { count, loading, error };
};
